import { ObjectWithUid } from "../utils.tsx";
import { ResponseWrapper, PagedResults, trackerGet, trackerPost, trackerPatch, trackerDelete, decodeResult } from "./basicApi.ts";
import { ParameterSettingsDto, ParameterSettingsDetailsDto } from "./parameterSettings.ts";


interface ScanTypeDto extends ObjectWithUid {
  slug: string;
  name: string;
  slug_beamline: string;
  description?: string;
  slug_derived_from?: string;
  deprecated: boolean;
  parameters: ParameterSettingsDto[];
  date_last_modified: string;
  date_record_created: string;
}


interface ScanTypeDetailsDto extends ObjectWithUid {
  slug: string;
  name: string;
  slug_beamline: string;
  description?: string;
  slug_derived_from?: string;
  deprecated: boolean;
  parameters: ParameterSettingsDetailsDto[];
  date_last_modified: string;
  date_record_created: string;
}


interface ScanTypeCreateDto {
  slug?: string;
  name: string;
  slug_beamline: string;
  description?: string;
  slug_derived_from?: string;
}


interface ScanTypeUpdateDto {
  slug: string;
  name?: string;
  description?: string;
  deprecated?: boolean;
}


// Get a list of ScanTypes the logged-in user has access to
async function getScanTypes(): Promise<ResponseWrapper<PagedResults<ScanTypeDto>>> {
  const result = await trackerGet(`scantypes/`, {});
  return decodeResult(result);
}


async function getScanTypeDetailsBySlug(slug: string): Promise<ResponseWrapper<ScanTypeDetailsDto>> {
  const result = await trackerGet(`scantypes/${slug}/details/`, {});
  return decodeResult(result);
}


// Create a ScanType record on the server
async function createScanType(dto: ScanTypeCreateDto): Promise<ResponseWrapper<ScanTypeDto>> {
  const result = await trackerPost(`scantypes/`, JSON.stringify(dto));
  return decodeResult(result);
}


// Update a ScanType record on the server.
async function updateScanType(dto: ScanTypeUpdateDto): Promise<ResponseWrapper<ScanTypeDto>> {
  const result = await trackerPatch(`scantypes/${dto.slug}/`, JSON.stringify(dto));
  return decodeResult(result);
}


// Delete a ScanType record from the server, returning the Id used if successful.
async function deleteScanType(slug: string): Promise<ResponseWrapper<string>> {
  const result = await trackerDelete(`scantypes/${slug}/`, {});
 if (result.success) {
   return { success: true, response: slug };
 }
 return { success: false, message: result.message };
}


export type { ScanTypeDto, ScanTypeDetailsDto, ScanTypeCreateDto, ScanTypeUpdateDto };
export { getScanTypes, getScanTypeDetailsBySlug, createScanType, updateScanType, deleteScanType }
